<template>
  <div class="stat-list">
    <div
      v-for="item in list"
      :key="item.key"
      :class="['stat-list-item', item.pathname && 'can-click']"
      v-loading="loading"
      @click="goPath(item)"
    >
      <div class="stat-item-type">
        <span>{{ item.label }}</span>
        <el-tooltip
          v-if="item.tipText"
          class="item"
          effect="light"
          placement="top"
        >
          <div slot="content">
            {{ item.tipText }}
          </div>
          <i class="icon iconfont icon-help stat-item-help"></i>
        </el-tooltip>
      </div>
      <div class="stat-item-total">{{ item.total }}</div>
      <div class="stat-item-scale">
        <div>
          <span>本月新增</span>
          <span class="stat-item-scale-count">{{ item.monthInc }}</span>
          <span
            v-if="item.monthAdd"
            class="stat-item-scale-top stat-item-scale-icon"
          ></span>
          <span v-else class="stat-item-scale-down stat-item-scale-icon"></span>
        </div>
        <div>
          <span>本周新增</span>
          <span class="stat-item-scale-count">{{ item.weekInc }}</span>
          <span
            v-if="item.weekAdd"
            class="stat-item-scale-top stat-item-scale-icon"
          ></span>
          <span v-else class="stat-item-scale-down stat-item-scale-icon"></span>
        </div>
      </div>
      <div class="stat-item-footer">{{ item.statFooter }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatList',
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goPath(row) {
      if (row.pathname) {
        this.$router.push({
          name: row.pathname,
          query: row.pathQuery || {},
        })
      }
    },
  },
}
</script>

<style lang='scss'>
.stat-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .stat-list-item {
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
    border-radius: 4px;
    width: 23.5%;
    height: 195px;
    margin-top: 20px;
    padding: 20px 2%;
    box-sizing: border-box;
    .stat-item-type {
      color: #999;
      .stat-item-help {
        color: #2397f3;
        font-size: 14px;
        margin-left: 10px;
        cursor: help;
      }
    }
    .stat-item-total {
      font-size: 46px;
      font-weight: bold;
      color: #333;
      margin: 6px 0 12px;
    }
    .stat-item-scale {
      display: flex;
      padding-bottom: 8px;
      margin-bottom: 8px;
      border-bottom: 1px solid #e8e8e8;
      font-size: 12px;
      color: #666666;
      & > div {
        display: flex;
        align-items: center;
      }
      & > div:nth-of-type(1) {
        margin-right: 16%;
      }
      .stat-item-scale-count {
        margin-right: 6px;
        margin-left: 6px;
      }
      .stat-item-scale-top {
        border: 6px solid #f5222d;
        border-left: 5px solid #fff;
        border-right: 5px solid #fff;
        border-top: none;
      }
      .stat-item-scale-down {
        border: 6px solid #52c41a;
        border-left: 5px solid #fff;
        border-right: 5px solid #fff;
        border-bottom: none;
      }
      .stat-item-scale-icon {
        margin-top: 2px;
      }
    }
    .stat-item-footer {
      color: #333333;
    }
  }
  .can-click {
    cursor: pointer;
  }
}
</style>